import moment from "moment";



function formatedDateOnly(date){


    return  moment(date).format("DD-MMM-YYYY")  //for date without time

    
}

export default formatedDateOnly;